import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

function LinkGroup(props) {
    const { buttonId, buttonClassName, label, buttons, alignEnd } = props;
    const className = `${buttonClassName} dropdown-toggle dropdown-toggle-split`;
    const dropdownMenuClass = `dropdown-menu ${alignEnd ? "dropdown-menu-end-force" : ""}`;
    return (
        <div className="dropdown">
            <button type="button" id={buttonId} className={className} data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span>{label}</span>
                <FontAwesomeIcon className="ms-2" icon={faAngleDown} />
            </button>
            <ul className={dropdownMenuClass} aria-labelledby={buttonId}>
                {
                    buttons.map(function (button, i) {
                        return <li key={i}><Link id={button.id} className="dropdown-item" to={button.to}>{button.label}</Link></li>
                    })
                }
            </ul>
        </div >
    )
}

export default LinkGroup;
